import { ClassNameFormatter } from "@bem-react/classname";
import { bemClassNames } from "@multiweb/reactUtils";
import { GeneralItemRenderer } from "../GeneralItemRenderer";

const classNames = bemClassNames("tree-frame-item-renderer");

export class TreeFrameItemRenderer extends GeneralItemRenderer {
    public override get classNames(): ClassNameFormatter {
        return classNames;
    }
}
